import fetch from 'cross-fetch'

class ApiService {
  /**
   *
   * @param path
   * @param data
   * @returns {Promise<* | void>}
   * @constructor
   */
  static async GET (path, data = null) {
    const headers = await getHeaders()
    const options = getOptions()
    let port = ''
    if (document.location.port) {
      port = `:${document.location.port}`
    }
    if (process.env.NODE_ENV === 'development') {
      path = `http://mci.dev.kyoconseil.com${port}${path}`
    }
    if (data) {
      path += `?${new URLSearchParams(data)}`
    }
    return fetch(path, {
      method: 'GET',
      ...options,
      headers
    })
      .then(response => {
        if (response.status === 200) {
          return response.json()
        } else {
          return null
        }
      })
      .catch(e => {
        throw e
      })
  }

  /**
   *
   * @param path
   * @param data
   * @returns {Promise<any>}
   * @constructor
   */
  static async POST (path, data = {}) {
    const headers = await getHeaders()
    const options = getOptions()
    let port = ''
    if (document.location.port) {
      port = `:${document.location.port}`
    }
    if (process.env.NODE_ENV === 'development') {
      path = `http://mci.dev.kyoconseil.com${port}${path}`
    }
    return fetch(path, {
      method: 'POST',
      ...options,
      body: JSON.stringify(data),
      headers
    })
      .then(response => {
        return response.json()
      })
      .catch(err => {
        console.error(err)
      })
  }
}

function getOptions () {
  const options = {}
  if (process.env.NODE_ENV === 'development') {
    options.mode = 'cors'
    options.withCredentials = true // <-- ADD THIS
    options.credentials = 'include'
  }
  return options
}

async function getHeaders () {
  return {
    'Content-Type': 'application/json'
  }
}

export default ApiService
